export default __webpack_public_path__ + "static/media/pexels-fauxels-3184418.904bb375.jpg";